module.exports = __webpack_public_path__ + "img/百香果4.dfc768f9.png";